<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item label="发送时间：">
      <el-date-picker
        v-model="filters.dateTime"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        unlink-panels
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.pushBizType"
        placeholder="消息类型"
      >
        <el-option
          v-for="(item, i) in pushBizTypes"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-input
        class="filter-input"
        prefix-icon="el-icon-search"
        v-model="filters.nameOrMobile"
        placeholder="接收人姓名/手机"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getDataMap } from "@/api/sysParam";

export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      filters: {},
      pushBizTypes: [],
    };
  },
  created() {
    getDataMap("PUSH_BIZ_TYPE").then((res) => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        paramKey: "",
        paramValue: "全部消息分类",
      });
      this.pushBizTypes = res.data;
    });
  },
  methods: {
    initData() {
      let params = Object.assign({}, this.filters);
      delete params.dateTime;
      if (this.filters.dateTime) {
        params["startDate"] = this.filters.dateTime[0];
        params["endDate"] = this.filters.dateTime[1];
      }
      this.$emit("search", { ...params, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>

<style scoped>
.filter-input {
  width: 220px;
}
</style>
